import { render, staticRenderFns } from "./healthPc.vue?vue&type=template&id=5bd58ed6&scoped=true"
import script from "./healthPc.vue?vue&type=script&lang=js"
export * from "./healthPc.vue?vue&type=script&lang=js"
import style0 from "./healthPc.vue?vue&type=style&index=0&id=5bd58ed6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bd58ed6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bd58ed6')) {
      api.createRecord('5bd58ed6', component.options)
    } else {
      api.reload('5bd58ed6', component.options)
    }
    module.hot.accept("./healthPc.vue?vue&type=template&id=5bd58ed6&scoped=true", function () {
      api.rerender('5bd58ed6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/inspect/healthPc.vue"
export default component.exports